import { useSelector } from 'react-redux';

import { RootState } from '../redux/store';
import { isLoggedIn } from '../utils/utils';
import { Navigate } from 'react-router-dom';
import { NAVIGATE_ADMIN } from '../constant';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
    const authUser = useSelector((state: RootState) => state.authUser);
    if (isLoggedIn(authUser)) {
        if (authUser.userDetails) {
            return <Navigate to={NAVIGATE_ADMIN.DASHBOARD_PAGE} />
        }
    }

    return (
        <>{children}</>
    )
}

export default AuthLayout;